import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useUpdateClient = () => {
  return usePost({ url: ApiRoutesEnum.updateClient });
};
